const stateName = 'AnalyticalPlan ';

export class InitAnalyticalDistributionAction {
    public static type = stateName + 'init distribution infos';

    constructor(public data: {accountId: number, analyticalSectionId?: number, overpaymentAmount: number}) {
    }
}

export class AnalyticalPlanInitAnalyticalParametersAction {
    public static type = stateName + 'InitAnalyticalParameters';
}

export class ResetAnalyticalPlanStateAction {
    public static type = stateName + 'reset distribution infos';
}
